import { BaseIntegration, BaseIntegrationState } from '@/models/integrations/BaseIntegration';
import { Component } from 'vue';
import { IntegrationCookieConsentData } from './Data';
import { CookieConsentOptions } from './Types';

export interface IntegrationCookieConsentState extends BaseIntegrationState {
  plugin?: CookieConsentOptions;
}

export class IntegrationCookieConsentModel extends BaseIntegration<
  IntegrationCookieConsentData,
  IntegrationCookieConsentState
> {
  parse(data: IntegrationCookieConsentData) {
    super.parse(data);
    this.state.plugin = data.settings?.plugin;
  }

  getVueComponent(): Promise<Component> {
    return import('@/components/integrations/cookie-consent/View.vue');
  }

  hasVueComponent() {
    return true;
  }

  authorSignature(): string {
    return 'Dannie Birk Hansen';
  }
}
